import { render, staticRenderFns } from "./Infos.vue?vue&type=template&id=0da61c8a&scoped=true&"
import script from "./Infos.vue?vue&type=script&lang=ts&"
export * from "./Infos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da61c8a",
  null
  
)

export default component.exports